export const permissionTypes = {
  "feed": ['feedView', 'feedEdit', 'feedDelete'],
  "campaign": ['campaignView', 'campaignEdit', 'campaignDelete', 'campaignAnalyze']
};